import { render } from "./RequestLoadingIndicator.vue?vue&type=template&id=2c3ff2eb&scoped=true"
import script from "./RequestLoadingIndicator.vue?vue&type=script&lang=js"
export * from "./RequestLoadingIndicator.vue?vue&type=script&lang=js"

import "./RequestLoadingIndicator.vue?vue&type=style&index=0&id=2c3ff2eb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c3ff2eb"]])

export default __exports__